<template>
  <div> <!--  v-if="!reload" -->
    <el-drawer
     class="text-left"
    :title="heading"
    append-to-body
    size="96.3%"
    :visible.sync="showModal"
    :class="bgClass"
    direction="btt">

      <div class="padded" style="text-align: left; min-height: 83.7%; max-height: 450px; text-align: left; overflow: auto;">
        <slot></slot>
      </div>

      <hr />
      <div class="padded pull-right">
        <component v-if="footerComponent" v-bind="extraProps" :is="footerComponent"></component>
        <el-button v-if="showCancel" @click="closeModal"><span v-if="showSave || showSavePublish">Cancel</span><span v-else>Close</span></el-button>
        <el-button v-if="showSave" type="success" :disabled="!allowSave" @click="saveModal">Save</el-button>
        <el-button v-if="showSavePublish" type="warning" :disabled="!allowSave" @click="savePublishModal">{{ savePublishText }}</el-button>
      </div>

    </el-drawer>

    <el-button
      :type="buttonStyle"
      :class="buttonClass"
      :size="this.getButtonSize()"
      @click="openModal"
      :text="text"
      :plain="plain"
      :round="round"
      :circle="circle"
      :disabled="disableButton || isViewOnly()"
      :aria-label="buttonAriaLabel"
      :title="buttonTitle">
      <i v-show="buttonIcon" :class="buttonIcon"></i>
      <span v-if="showText">{{buttonText}}</span>
    </el-button>

  </div>
</template>

<script>


import {ENABLE_SAVE_EVENT, DISABLE_SAVE_EVENT} from '@/components/Data'


export default {
  name: 'popup',

  props: {
    heading: {
      type: String,
      default: 'Alert Message'
    },
    size: {
      type: String,
      default: 'small'
    },
    buttonSize: {
      type: String,
      default: 'small'
    },
    buttonText: {
      type: String,
      required: true,
      default: 'Open'
    },
    buttonType: {
      type: String,
      default: 'normal'
    },
    buttonClass: {
      type: String,
      default: ''
    },
    showText: {
      type: Boolean,
      default: true
    },
    clickToClose: {
      type: Boolean,
      default: true
    },
    escToClose: {
      type: Boolean,
      default: true
    },
    beforeClose: {
      type: Function
    },
    beforeSave: {
      type: Function
    },
    buttonIcon: {
      type: String,
      default: ''
    },
    buttonStyle: {
      type: String,
      default: 'info'
    },
    bgClass: {
      type: String,
      default: null
    },
    round: {
      type: Boolean,
      default: false
    },
    text: {
      type: Boolean,
      default: false
    },
    circle: {
      type: Boolean,
      default: false
    },
    plain: {
      type: Boolean,
      default: false
    },
    disableButton: {
      type: Boolean,
      default: false
    },
    overideViewOnly: {
      type: Boolean,
      default: false
    },
    disableSave: {
      type: Boolean,
      default: false
    },
    showSave: {
      type: Boolean,
      default: true
    },
    showCancel: {
      type: Boolean,
      default: true
    },
    centerButton: {
      type: Boolean,
      default: false
    },
    appendBody: {
      type: Boolean,
      default: true
    },
    footerComponent: {
      type: Object
    },
    extraProps: {
      type: Object
    },
    tableRef: {
      type: String,
      default: null
    },
    buttonAriaLabel: {
      type: String,
      default: null
    },
    buttonTitle: {
      type: String,
      default: null
    },
    showSavePublish: {
      type: Boolean,
      default: false
    },
    savePublishText: {
      type: String,
      default: 'Save + Publish'
    }
  },

  components: {
  },

  methods: {
    refresh () {
      this.$forceUpdate()
    },

    getButtonSize () {
      return this.showText ? this.buttonSize : (this.buttonSize === 'small' || this.buttonSize === 'mini' ? this.buttonSize : 'small')
    },

    enabledSave () {
      this.allowSave = true
    },

    disabledSave () {
      this.allowSave = false
    },

    openModal () {
      this.showModal = true
    },

    saveModal () {

      // beforeSave gates the whole save (XOL-376): when provided and it returns
      // false, keep the modal open and do NOT emit @save or refresh the table —
      // the guard has already told the user what to fix. This honors the
      // contract documented at the DefaultTierTemplateButton call site; the old
      // behavior emitted @save even after a failed guard, so a blocked save
      // closed the drawer and hid the inline validation errors.
      if (this.beforeSave && !this.beforeSave()) return

      this.showModal = false
      this.$emit('save')

      if (this.tableRef) {
        this.$events.emit(this.tableRef + '-refresh-table')
      }

    },

    savePublishModal () {
      this.$emit('save-publish')
    },

    closeModal (destroy = false) {
      this.$emit('close')
      this.showModal = false
//      this.allowSave = false

      if (destroy) {
        this.reload = true
        this.$nextTick(() => {
// TODO          this.$destroy()
        })
      }
    }
  },

  data () {
    return {
      allowSave: this.disableSave ? this.disableSave : true,
      showModal: false,
      reload: false
    }
  },

  created () {

    this.$events.on(DISABLE_SAVE_EVENT, this.disabledSave)
    this.$events.on(ENABLE_SAVE_EVENT, this.enabledSave)

  },

  beforeDestroy () {
    this.$events.off(DISABLE_SAVE_EVENT, this.disabledSave)
    this.$events.off(ENABLE_SAVE_EVENT, this.enabledSave)
  }
}

</script>
